import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiEmptyListComponent } from './fi-empty-list.component';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule],
    declarations: [FiEmptyListComponent],
    exports: [FiEmptyListComponent],
})
export class FiEmptyListModule {}
